export const API_URL = process.env.REACT_APP_API_URL;

// Whole dollars, digits only. Unset or invalid keeps the long-standing $2,500.
const sellOrderLimitAmount = Number(process.env.REACT_APP_SELL_ORDER_LIMIT_AMOUNT);
export const SELL_ORDER_LIMIT_AMOUNT = sellOrderLimitAmount > 0 ? sellOrderLimitAmount : 2500;

export const REPORT_TYPE_MAP = {
    office_value_load_report_enabled: "office_value_load",
    office_mcr_reloadable_report_enabled: "office_mcr_reloadable",
    office_consolidated_transaction_report_enabled: "office_consolidated_transactions",
    office_t_plus_one_settlement_report_enabled: "office_t_plus_one_settlements",
    pwr_unload_report_enabled: "pwr_unloads",
    pwr_cra_payment_report_enabled: "pwr_cra_payments",
    mfa_transaction_report_enabled: "escrow_transactions",
    cra_dda_submission_report_enabled: "cra_dda_submission",
    cra_dda_pending_cases_report_enabled: "cra_dda_pending_cases"
};

export const authenticationLoginUrl = 'auth/login';
export const TOKEN_KEY = 'auth_token';
export const TOKEN_EXPIRATION_KEY = 'auth_token_expiration';
export const USER_DATA = 'auth_user_data';
export const SERVICE_CONFIG = 'service_config';
export const SELL_ORDER_LANDING = 'sell_order_landing';
export const ENABLE_OXFORD_SELL_ORDER_LIMIT = 'enable_oxford_sell_order_limit';